export default __webpack_public_path__ + "static/media/js.81902c4d.png";